import React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import "./LiveProducts.css";
import { Link } from "react-router-dom";

function LiveProducts() {
  const [womenProducts, setWomenProducts] = useState(null);
  const [menProducts, setMenProducts] = useState(null);
  const [careProducts, setCareProducts] = useState(null);

  useEffect(() => {
    (async () => {
      const resultWomen = await axios({
        method: "GET",
        url: "https://asos2.p.rapidapi.com/products/v2/list",
        params: {
          store: "US",
          offset: "0",
          categoryId: "26543",
          limit: "48",
          country: "US",
          sort: "freshness",
          currency: "USD",
          sizeSchema: "US",
          lang: "en-US",
        },
        headers: {
          "x-rapidapi-key":
            "c2148b3dfamshd0306d645183132p1c3dbdjsnb84cbd6468dd",
          "x-rapidapi-host": "asos2.p.rapidapi.com",
        },
      });

      setWomenProducts(resultWomen.data.products);
      console.log(womenProducts);

      const resultMen = await axios({
        method: "GET",
        url: "https://asos2.p.rapidapi.com/products/v2/list",
        params: {
          store: "US",
          offset: "0",
          categoryId: "19971",
          limit: "48",
          country: "US",
          sort: "freshness",
          currency: "USD",
          sizeSchema: "US",
          lang: "en-US",
        },
        headers: {
          "x-rapidapi-key":
            "c2148b3dfamshd0306d645183132p1c3dbdjsnb84cbd6468dd",
          "x-rapidapi-host": "asos2.p.rapidapi.com",
        },
      });

      setMenProducts(resultMen.data.products);
      console.log(menProducts);

      const resultCare = await axios({
        method: "GET",
        url: "https://asos2.p.rapidapi.com/products/v2/list",
        params: {
          store: "US",
          offset: "0",
          categoryId: "16070",
          limit: "48",
          country: "US",
          sort: "freshness",
          currency: "USD",
          sizeSchema: "US",
          lang: "en-US",
        },
        headers: {
          "x-rapidapi-key":
            "c2148b3dfamshd0306d645183132p1c3dbdjsnb84cbd6468dd",
          "x-rapidapi-host": "asos2.p.rapidapi.com",
        },
      });

      setCareProducts(resultCare.data.products);
      console.log(careProducts);
    })();
  }, []);

  useEffect(() => {
    console.log(womenProducts);
    console.log(menProducts);
    console.log(careProducts);
  }, [womenProducts, menProducts, careProducts]);

  return (
    <div className="home-products container ">
      <div id="otherslide" className="carousel slide " data-bs-ride="carousel">
        <div className="carousel-indicators d-none">
          <button
            type="button"
            data-bs-target="#otherslide"
            data-bs-slide-to="0"
            className="active"
            aria-current="true"
            aria-label="Slide 1"
          ></button>
          <button
            type="button"
            data-bs-target="#otherslide"
            data-bs-slide-to="1"
            aria-label="Slide 2"
          ></button>
          <button
            type="button"
            data-bs-target="#otherslide"
            data-bs-slide-to="2"
            aria-label="Slide 3"
          ></button>
        </div>
        <div className="carousel-inner">
          {womenProducts ? (
            <div className="carousel-item active">
              <div className="row">
                <div className="card col-lg-2 ">
                  <Link to={`/details/${womenProducts[0].id}`}>
                    <img
                      src={"http://" + womenProducts[0].imageUrl}
                      className="card-img-top"
                      alt=""
                    />
                  </Link>
                  <div className="card-body">
                    <h4>Women</h4>
                    <h5 className="card-title">{womenProducts[0].name}</h5>
                    <p className="card-text">
                      {womenProducts[0].price.current.text}
                      <del>{womenProducts[0].price.previous.text}</del>
                    </p>
                  </div>
                </div>

                <div className="card col-lg-2  ">
                  <Link to={`/details/${womenProducts[1].id}`}>
                    <img
                      src={"http://" + womenProducts[1].imageUrl}
                      className="card-img-top"
                      alt=""
                    />
                  </Link>

                  <div className="card-body">
                    <h4>Women</h4>
                    <h5 className="card-title">{womenProducts[1].name}</h5>
                    <p className="card-text">
                      {womenProducts[1].price.current.text}
                      <del>{womenProducts[1].price.previous.text}</del>
                    </p>
                  </div>
                </div>
                <div className="card col-lg-2 ">
                  <Link to={`/details/${womenProducts[2].id}`}>
                    <img
                      src={"http://" + womenProducts[2].imageUrl}
                      className="card-img-top"
                      alt=""
                    />
                  </Link>

                  <div className="card-body">
                    <h4>Women</h4>
                    <h5 className="card-title">{womenProducts[2].name}</h5>
                    <p className="card-text">
                      {womenProducts[2].price.current.text}
                      <del>{womenProducts[2].price.previous.text}</del>
                    </p>
                  </div>
                </div>
                <div className="card col-lg-2 ">
                  <Link to={`/details/${womenProducts[3].id}`}>
                    <img
                      src={"http://" + womenProducts[3].imageUrl}
                      className="card-img-top"
                      alt=""
                    />
                  </Link>

                  <div className="card-body">
                    <h4>Women</h4>
                    <h5 className="card-title">{womenProducts[3].name}</h5>
                    <p className="card-text">
                      {womenProducts[3].price.current.text}
                      <del>{womenProducts[3].price.previous.text}</del>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ) : null}

          {menProducts ? (
            <div className="carousel-item ">
              <div className="row">
                <div className="card col-lg-2">
                  <Link to={`/details/${menProducts[3].id}`}>
                    <img
                      src={"http://" + menProducts[3].imageUrl}
                      className="card-img-top"
                      alt=""
                    />
                  </Link>

                  <div className="card-body">
                    <h4>Men</h4>
                    <h5 className="card-title">{menProducts[3].name}</h5>
                    <p className="card-text">
                      {menProducts[3].price.current.text}
                      <del>{menProducts[3].price.previous.text}</del>
                    </p>
                  </div>
                </div>
                <div className="card col-lg-2">
                  <Link to={`/details/${menProducts[4].id}`}>
                    <img
                      src={"http://" + menProducts[4].imageUrl}
                      className="card-img-top"
                      alt=""
                    />
                  </Link>

                  <div className="card-body">
                    <h4>Men</h4>
                    <h5 className="card-title">{menProducts[4].name}</h5>
                    <p className="card-text">
                      {menProducts[4].price.current.text}
                      <del>{menProducts[4].price.previous.text}</del>
                    </p>
                  </div>
                </div>
                <div className="card col-lg-2">
                  <Link to={`/details/${menProducts[5].id}`}>
                    <img
                      src={"http://" + menProducts[5].imageUrl}
                      className="card-img-top"
                      alt=""
                    />
                  </Link>

                  <div className="card-body">
                    <h4>Men</h4>
                    <h5 className="card-title">{menProducts[5].name}</h5>
                    <p className="card-text">
                      {menProducts[5].price.current.text}
                      <del>{menProducts[5].price.previous.text}</del>
                    </p>
                  </div>
                </div>
                <div className="card col-lg-2">
                  <Link to={`/details/${menProducts[6].id}`}>
                    <img
                      src={"http://" + menProducts[6].imageUrl}
                      className="card-img-top"
                      alt=""
                    />
                  </Link>

                  <div className="card-body">
                    <h4>Men</h4>
                    <h5 className="card-title">{menProducts[6].name}</h5>
                    <p className="card-text">
                      {menProducts[6].price.current.text}
                      <del>{menProducts[6].price.previous.text}</del>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          {careProducts ? (
            <div className="carousel-item ">
              <div className="row">
                <div className="card col-lg-2">
                  <Link to={`/details/${careProducts[3].id}`}>
                    <img
                      src={"http://" + careProducts[3].imageUrl}
                      className="card-img-top"
                      alt=""
                    />
                  </Link>

                  <div className="card-body">
                    <h4>Face & Body</h4>
                    <h5 className="card-title">{careProducts[3].name}</h5>
                    <p className="card-text">
                      {careProducts[3].price.current.text}
                      <del>{careProducts[3].price.previous.text}</del>
                    </p>
                  </div>
                </div>
                <div className="card col-lg-2">
                  <Link to={`/details/${careProducts[2].id}`}>
                    <img
                      src={"http://" + careProducts[2].imageUrl}
                      className="card-img-top"
                      alt=""
                    />
                  </Link>

                  <div className="card-body">
                    <h4>Face & Body</h4>
                    <h5 className="card-title">{careProducts[2].name}</h5>
                    <p className="card-text">
                      {careProducts[2].price.current.text}
                      <del>{careProducts[2].price.previous.text}</del>
                    </p>
                  </div>
                </div>
                <div className="card col-lg-2">
                  <Link to={`/details/${careProducts[5].id}`}>
                    <img
                      src={"http://" + careProducts[5].imageUrl}
                      className="card-img-top"
                      alt=""
                    />
                  </Link>

                  <div className="card-body">
                    <h4>Face & Body</h4>
                    <h5 className="card-title">{careProducts[5].name}</h5>
                    <p className="card-text">
                      {careProducts[5].price.current.text}
                      <del>{careProducts[5].price.previous.text}</del>
                    </p>
                  </div>
                </div>
                <div className="card col-lg-2">
                  <Link to={`/details/${careProducts[4].id}`}></Link>
                  <img
                    src={"http://" + careProducts[4].imageUrl}
                    className="card-img-top"
                    alt=""
                  />
                  <div className="card-body">
                    <h4>Face & Body</h4>
                    <h5 className="card-title">{careProducts[4].name}</h5>
                    <p className="card-text">
                      {careProducts[4].price.current.text}
                      <del>{careProducts[4].price.previous.text}</del>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
        <button
          className="carousel-control-prev "
          type="button"
          data-bs-target="#otherslide"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon bg-dark "
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#otherslide"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon  bg-dark"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
}

export default LiveProducts;
